{
  "DeleteReminder": "Excluir lembrete",
  "EditReminder": "Editar lembrete",
  "RemindMe15Min": "Lembre-me em 15 minutos",
  "RemindMe5Min": "Lembre-me em 5 minutos",
  "RemindMe60Min": "Lembre-me em uma hora",
  "RemindMeTomorrow": "Lembrar amanhã",
  "SetReminder": "Lembrete definido para {formattedReminderTime}",
  "Snooze": "Adiar"
}
